/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum BackendForAppErrorCode {
  None = 'None',
  NotAuthorized = 'NotAuthorized',
  IconNotFound = 'IconNotFound',
  StreamNotAvailable = 'StreamNotAvailable',
  VaultNotFound = 'VaultNotFound',
  UserNotFound = 'UserNotFound',
  SearchResultsNotFound = 'SearchResultsNotFound',
  ServerMaintenance = 'ServerMaintenance',
  DocumentNotFound = 'DocumentNotFound',
  LanguageCultureNotFound = 'LanguageCultureNotFound',
  AiServicesNotEnabled = 'AiServicesNotEnabled',
  NoReadableDocuments = 'NoReadableDocuments',
  AiNotEnoughQuota = 'AiNotEnoughQuota',
  InvalidModelState = 'InvalidModelState',
  MagnetNotFound = 'MagnetNotFound',
  InvalidDocumentId = 'InvalidDocumentId',
  InvalidArgument = 'InvalidArgument',
  InvalidTagValue = 'InvalidTagValue',
  DocumentCurrentlyNotEditable = 'DocumentCurrentlyNotEditable',
  TagDefinitionVersionChanged = 'TagDefinitionVersionChanged',
  RequiredTagValue = 'RequiredTagValue',
  ReadonlyTagValue = 'ReadonlyTagValue',
  DocumentNameAlreadyExists = 'DocumentNameAlreadyExists',
  TagNotFound = 'TagNotFound',
  ClickFinderNodeNotFound = 'ClickFinderNodeNotFound',
  SearchQueryNotFound = 'SearchQueryNotFound',
  ConditionNotFound = 'ConditionNotFound',
  DocumentDeleted = 'DocumentDeleted',
  DocumentIsNotLocked = 'DocumentIsNotLocked',
  DocumentIsLockedByOtherUser = 'DocumentIsLockedByOtherUser',
  DocumentCurrentlyNotStampable = 'DocumentCurrentlyNotStampable',
  InvalidStampActionResponse = 'InvalidStampActionResponse',
  AbortedByStampAction = 'AbortedByStampAction',
  StampInputRequired = 'StampInputRequired',
  StampedValueIsNotAllowed = 'StampedValueIsNotAllowed',
  StampNotFound = 'StampNotFound',
  StampWithDuplicatedMmsNotUsable = 'StampWithDuplicatedMmsNotUsable',
  ArchivationIsNotAuthorizedForDocument = 'ArchivationIsNotAuthorizedForDocument',
  StampIsNotVisual = 'StampIsNotVisual',
  TagDefinitionNotFound = 'TagDefinitionNotFound',
  StampTagNotFound = 'StampTagNotFound',
  DocumentPageNotFound = 'DocumentPageNotFound',
  ConditionIsNotUsableWithMagnets = 'ConditionIsNotUsableWithMagnets',
  InvalidCondition = 'InvalidCondition',
  MissingSearchQueryName = 'MissingSearchQueryName'
}
